/** DeployWebPlacementDialog test ids — mirrored in @test-kit WP.deploy* (keep in sync). */
export const DEPLOY_DIALOG_TEST_IDS = {
  dialog: 'wp-deploy-dialog',
  doneBtn: 'wp-deploy-done-btn',
  retryBtn: 'wp-deploy-retry-btn',
  publishedUrlLink: 'wp-deploy-published-url-link',
  copyUrlBtn: 'wp-deploy-copy-url-btn',
} as const;
